import { Link } from 'react-router-dom';
import { Routes } from '@/routes';
import { Credit } from '..';

export function CreditButton() {
  return (
    <Link
      to={Routes.UserWallet}
      className="flex justify-center items-center no-underline ms-auto pe-1"
    >
      <span className="flaticon-wallet px-1" style={{ color: '#0b5e62' }} />
      <Credit inline numColor="#0b5e62" postfixColor="#0b5e62" />
    </Link>
  );
}

export default CreditButton;
